module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/icon_title_hat-788f26b14f0f9f0bdb863e702f13de28.svg";